import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AppNavbar from './Navbar';
import MobileNavbar from './MobileNavbar';
import AskQuestion from './AskQuestion';
import { useAuth } from '../contexts/AuthContext';
import Calendar from "@/components/Calendar.jsx";
import FeedsDashboard from "@/components/FeedsDashboard.jsx";
import { useDevice } from '../contexts/DeviceContext';

const Dashboard = ( page = 'home') => {
    const { user, userProfile } = useAuth();
    const { isMobile } = useDevice();
    const [activeComponent, setActiveComponent] = useState('home');

    // Handle navigation item click
    const handleNavItemClick = (itemId) => {
        setActiveComponent(itemId);
    };

    // Effect to check device size and set active component accordingly
    useEffect(() => {
        // Default to showing everything on desktop
        if (!isMobile) {
            setActiveComponent('home');
        }else{
            setActiveComponent(page.page);
        }
    }, [isMobile, page]);

    // Render the active component for mobile view
    const renderActiveComponent = () => {
        switch (activeComponent) {
            case 'home':
                return <AskQuestion user={user} />;
            case 'calendar':
                return <Calendar user={user} />;
            case 'feed':
                return <FeedsDashboard user={user} />;
            case 'memory':
                // Redirect to Submissions page or show component
                window.location.href = '/submissions';
                return null;
            case 'todos':
                // Redirect to Feeds page or show component
                window.location.href = '/todos';
                return null;
            case 'settings':
                // Redirect to Settings page
                window.location.href = '/settings';
                return null;
            default:
                return <AskQuestion user={user} />;
        }
    };

    return (
        <div className="dashboard-wrapper">
            {/* Regular Navbar for Desktop */}
            <div className="d-none d-md-block">
                <AppNavbar />
            </div>

            {/* Mobile Navbar */}
            <MobileNavbar
                onNavItemClick={handleNavItemClick}
                activeItem={activeComponent}
            />

            {/* Dashboard Content */}
            <Container fluid className="dashboard-container">
                {isMobile ? (
                    // Mobile View - Show only the active component
                    <Row className="dashboard-row">
                        <Col className="dashboard-col">
                            {renderActiveComponent()}
                        </Col>
                    </Row>
                ) : (
                    // Desktop View - Show all components
                    <Row className="dashboard-row" style={{ margin: 0 }}>
                        <Col md={7} className="dashboard-col dashboard-col-left" style={{ padding: 0 }}>
                            <AskQuestion user={user}/>
                        </Col>
                        <Col md={5} className="dashboard-col dashboard-col-right" style={{ padding: '25px 21px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <Calendar user={user}/>
                            <FeedsDashboard user={user}/>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
};

export default Dashboard;
